const globalThis: any = global;
const { ROOT_DIR, __DEVELOPMENT__ } = globalThis;

export { ROOT_DIR, __DEVELOPMENT__ };
